import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "../../../../utils"
import { BackgroundOnlyFragment } from "../BackgroundOnly/BackgroundOnly.fragment"
import { TextOnlyFragment } from "../TextOnly/TextOnly.fragment"

export const TextWithBackgroundFragment = graphql(
  `
    fragment TextWithBackground on CollectionNarrativeModule {
      title
      description
      verticalTextPosition
      horizontalTextPosition
      desktopBackgroundMedia {
        ...MediaProps
      }
      mobileBackgroundMedia {
        ...MediaProps
      }
      ...BackgroundOnly
      ...TextOnly
    }
  `,
  [BackgroundOnlyFragment, TextOnlyFragment, getMediaPropsFromMediaFragment],
)
